import React from "react";
import { InputWithLabel } from "../../../components/micro";

const ConfigurationShares = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
}) => {
  return (
    <div className="space-y-3">
      <p>Configuration Shares</p>
      <div className="grid grid-cols-2 gap-3">
        <div className="text-sm space-y-1">
          <p>Current Paid-up Capital:</p>
          <p className="text-theme">Value</p>
        </div>
        <InputWithLabel
          className={
            errors?.paid_up_capital && touched?.paid_up_capital
              ? "input-error"
              : "border"
          }
          label={"New Paid-up Capital"}
          idFromName={"paid_up_capital"}
          type={"number"}
          value={values?.paid_up_capital}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors?.paid_up_capital && touched?.paid_up_capital}
          errorsText={errors?.paid_up_capital}
        />
        <div className="text-sm space-y-1">
          <p>Current Issued Share Capital:</p>
          <p className="text-theme">Value</p>
        </div>
        <InputWithLabel
          className={
            errors?.issued_share_capital && touched?.issued_share_capital
              ? "input-error"
              : "border"
          }
          label={"New Issued Share Capital"}
          idFromName={"issued_share_capital"}
          type={"number"}
          value={values?.issued_share_capital}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors?.issued_share_capital && touched?.issued_share_capital}
          errorsText={errors?.issued_share_capital}
        />
        <div className="text-sm space-y-1">
          <p>Total Number of Shares:</p>
          <p className="text-theme">Value</p>
        </div>
        <InputWithLabel
          className={
            errors?.total_number_of_shares && touched?.total_number_of_shares
              ? "input-error"
              : "border"
          }
          label={"New Number Share Capital"}
          idFromName={"total_number_of_shares"}
          type={"number"}
          value={values?.total_number_of_shares}
          onChange={handleChange}
          onBlur={handleBlur}
          errors={
            errors?.total_number_of_shares && touched?.total_number_of_shares
          }
          errorsText={errors?.total_number_of_shares}
        />
      </div>
    </div>
  );
};

export default ConfigurationShares;
